import axios from "../../api/javaApiInstance";

export function fetchSuppliers() {
  return axios
    .request("/broadband-supplier")
    .then(({ data }) => data._embedded["broadband-supplier"]);
}
